import router from './router'
import store from './store'
import { getToken } from '@/utils/auth' // getToken from cookie
import { setCookie, getCookie, clearCookie, urlParamsToObject } from '@/utils/tools'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import signalrNotify from '@/utils/signalR'
import { createLoginSign } from '@/api/system'

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/login', '/redirect', '/loginAuto','/clientAutoLogin',  '/oidc-callback', '/404', '/500', '/welcome','/forgetPassword','/moodle', '/retrieveEmail','/tutorClient']// no redirect whitelist

router.beforeEach(async (to, from, next) => {
  NProgress.start() // start progress bar

  await store.dispatch('initSystemSetting')

  let token = getToken()
  let redirectUrl = ''
  try {
    let _href = location.href

    if(_href.indexOf('?')>-1){
        let paraStr = _href.substring(_href.indexOf('?') + 1)
        let para = urlParamsToObject(paraStr)
        //client=tutorclient
        if(para.client){
            console.log('client',para.client)
            if(para.client=='tutorclient'){
                setCookie('client',para.client,100)
                //window.name='tutorclient'
                //alert(JSON.stringify(para))
            }
        }
    }

    // if(window.name=='tutorclient'){
    //   console.log(window.name)
    //   setCookie('client','tutorclient')
    // }
    
    if (_href.indexOf('#') > -1) {
      let paraStr = _href.substring(_href.indexOf('#') + 1)
      var para = urlParamsToObject(paraStr)
      redirectUrl = para.redirectUrl
      store.dispatch("setAuthStr",paraStr)
      console.log('LoginThree')
      token = await store.dispatch('LoginThree', para)
      if(para.client){
        if(para.client=='tutorclient'){
          setCookie('client',para.client,100)
        }
      }
    }

    if (to.path === '/oidc-callback') {
      //客户端获取LoginSign
      if(getCookie('client')=='tutorclient'){
        createLoginSign().then(res=>{
            console.log('客户端获取LoginSign:',res)
            if(res.data.ErrorCode == 0){
              setCookie('loginSign',res.data.Msg,30)
            }
        })
        if(window.GetTeachUserData){
          if(store.state.user.tuid && store.state.user.tuid>0){
            console.log('调用window.GetTeachUserData上传参数给客户端')
            window.GetTeachUserData(JSON.stringify({
                TUID:store.state.user.tuid,
                Token:store.state.user.actoken
            }));
          }
        }else{
            console.log('window.GetTeachUserData客户端方法不存在')
        }

      }
      


      next({ path: '/home' })
      NProgress.done()
      return
    } else if (to.path === '/redirect') {
      next({ path: redirectUrl || '/home' })
      NProgress.done()
      return
    }
    let _whiteList=store.state.layout.whiteList
    let _currDomain=_whiteList.find(t=>t.domain===`${location.protocol}//${location.host}`)
    if(!_currDomain || _currDomain.redirect===1){
      let rexHost = /http[s]?:\/\/(.+?)\//
      let rexRoute = /\/(\w+)\/?/
      let routeParent = (rexRoute.test(to.path) && to.path.match(rexRoute)[1]) || to.path
      let menu = store.state.layout.menus.find(e => e.routeName === routeParent)
      //有指定菜单域名的才做跳转
      if (menu && menu.url && rexHost.test(menu.url) && menu.url.match(rexHost)[1] !== location.host) {
        //跳转菜单站点
        if(getCookie('client')=='tutorclient'){
          location.href = `${menu.url.match(/(http[s]?:\/\/.+?)\//)[1]}/redirect#access_token=${token}&redirectUrl=${to.path}&client=tutorclient`
        }else{
          location.href = `${menu.url.match(/(http[s]?:\/\/.+?)\//)[1]}/redirect#access_token=${token}&redirectUrl=${to.path}`
        }
        return
      }else if(_currDomain && _currDomain.level===1){
        //不需要处理
      }else if(menu && (!menu.url || !rexHost.test(menu.url))){
          //跳转主站点
        let _mainDomain=_whiteList.find(t=>t.level===1)
        if(_mainDomain && _mainDomain.domain!==`${location.protocol}//${location.host}`){
          if(getCookie('client')=='tutorclient'){
            location.href = `${_mainDomain.domain}/redirect#access_token=${token}&redirectUrl=${to.path}&client=tutorclient`
          }else{
            location.href = `${_mainDomain.domain}/redirect#access_token=${token}&redirectUrl=${to.path}`
          }
          return
        }
      }
    }
  } catch (error) {
    console.log('error', error)
  }


  if (token) { // determine if there has token
    if (to.path === '/welcome' || to.path === '/login') {
      next({ path: '/home' })
      NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
    } else if (to.path === '/404' || to.path === '/500') {
      next()
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        //await store.dispatch('getLimit') //获取用户可放课时，因全屏组件的渲染顺序问题，需优先执行
        store.dispatch('GetUserInfo').then(data => { // 拉取user_info

          signalrNotify.start()

          store.dispatch("GetUserMoreInfo")
          store.dispatch("setEntryKey")
          store.dispatch('GrowthSystemIsFirstLogin') //获取成长体系首次登录否
          store.dispatch('GetUserAllScore') // 拉取用户分数信息
          store.dispatch('GetOpenSelfCacel')
          store.dispatch('GetTutorTrail') // 获取转化课时数
          store.dispatch('GetTutorHomeTask') //获取成长体系相关数据
          store.dispatch('GetGradeHonorDetail')//等级勋章数据
          //store.dispatch('GetMedalDetail')//荣誉勋章数据
          store.dispatch('GetMilestoneList')//勋章墙-里程碑勋章
          store.dispatch('GetPetInfo')
          store.dispatch('setAcToken')

          const roles = data.roles
          store.dispatch('GenerateRoutes', { roles }).then((routes) => { // 根据roles权限生成可访问的路由表
            router.addRoutes(routes) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          })

        }).catch(async (err) => {
          console.log('err', err)
          console.log('dispatch logout')

          await store.dispatch('FedLogOut')

          let retryTimes = getCookie('retryTimes') || 0
          if (retryTimes < 3) {
            setCookie('retryTimes', ++retryTimes)
            next({ path: '/welcome' })
          } else {
            console.log('clearCookie')
            clearCookie('retryTimes')
            location.href = "/500";
            //next({ path: '/500' })
          }
        })
      } else {
        next()
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/welcome`) // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

router.onError((error) => { // 路由异常,重新渲染
  console.log('router-error', error)
  const pattern = /Loading chunk chunk-(\w)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})
